import { Button } from 'primereact/button';
import { Menu as PrimeMenu } from 'primereact/menu';
import React, { MouseEvent, useRef } from 'react';

import { useMindmap } from '../use-mindmap';
import { ContextMenuType } from '../use-mindmap-context-menu';
import { ManipulationActions } from '../use-mindmap-manipulation';
import { Menu, MenuVariantElementProps } from './use-tool-bar';

const buttonClasses = 'p-button-text';

const menu1Small = ({ hook }: MenuVariantElementProps) => {
  const values = hook();
  if (values?.type == 'node-attachement') {
    const {
      actions: { onAddLinkAttachementClick, onAddFileAttachementClick, addAttachementSelectable },
      menuRef,
      positionContextMenu,
      setActiveMenu,
    } = values;

    const items = [
      {
        label: 'Link',
        icon: 'pi pi-external-link',
        command: (e: any) => {
          positionContextMenu(e.originalEvent, false);
          setActiveMenu({
            type: 'add-link-attachement',
            onCreateClick: (attachement) => {
              onAddLinkAttachementClick(attachement);
              setActiveMenu(undefined);
            },
          });
          e.preventDefault();
          e.stopPropagation();
        },
        disabled: addAttachementSelectable,
      },
      {
        label: 'File / Image',
        icon: 'pi pi-file',
        command: (e: any) => {
          positionContextMenu(e.originalEvent, false);
          setActiveMenu({
            type: 'add-file-attachement',
            onCreateClick: (attachement) => {
              onAddFileAttachementClick(attachement);
              setActiveMenu(undefined);
            },
          });
          e.preventDefault();
          e.stopPropagation();
        },
        disabled: addAttachementSelectable,
      },
    ];

    const onMenuClick = (event: any) => {
      // @ts-ignore
      menuRef.current.toggle(event);
    };

    return (
      <div style={{ gridColumn: '1 / 2', gridRow: '1 / 2' }}>
        <PrimeMenu model={items} ref={menuRef} popup id="node_attachement_popup_menu" />
        <Button
          label="Anhang hinzufügen"
          icon="pi pi-link"
          className={buttonClasses}
          disabled={addAttachementSelectable}
          onClick={onMenuClick}
          aria-controls="node_attachement_popup_menu"
          aria-haspopup
        />
      </div>
    );
  }
  throw new Error('Unknown or missing hook or hook type.');
};

export interface NodeAttachementHookValue {
  type: 'node-attachement';
  actions: ManipulationActions;
  menuRef: React.MutableRefObject<null>;
  positionContextMenu: (e: MouseEvent, animate: boolean) => void;
  setActiveMenu: React.Dispatch<React.SetStateAction<ContextMenuType | undefined>>;
}

export const nodeAttachementMenu: Menu = {
  id: 'menu-attachement',
  variants: [
    { Element: menu1Small, priority: 3 },
    { Element: menu1Small, priority: 3 },
    { Element: menu1Small, priority: 3 },
  ],
  currentVariant: 2,
  hook: () => {
    const menuRef = useRef(null);
    const {
      manipulation: { actions },
      interactableMap: { positionContextMenu },
      contextMenu: { setActiveMenu },
    } = useMindmap();

    return { type: 'node-attachement', actions, menuRef, positionContextMenu, setActiveMenu };
  },
  tempHook: () => ({
    type: 'node-attachement',
    actions: {
      addBottomSiblingSelectable: false,
      addChildSelectable: false,
      addTopSiblingSelectable: false,
      deleteSelectable: false,
      onAddBottomSiblingClick: () => {},
      onAddChildClick: () => {},
      onAddTopSiblingClick: () => {},
      onDeleteClick: () => {},
      onAddLinkAttachementClick: () => {},
      onAddFileAttachementClick: () => {},
      addAttachementSelectable: false,
    },
    menuRef: React.createRef(),
    positionContextMenu: () => {},
    setActiveMenu: () => {},
  }),
};
